export default __webpack_public_path__ + "static/media/database-solid.a899eced.svg";